/**
 * Switch — kit-styled toggle. All chrome lives in CSS class `.d-switch`
 * (see `dashboard-tokens.css`). Hidden native `<input type="checkbox">`
 * + `<span class="track">` whose `::after` pseudo is the handle. CSS
 * animates background + handle position on `:checked`.
 *
 * Track size 32×18, ink-coloured when on. Pure CSS — no inline color
 * juggling, no hardcoded teal / zinc that drifted from the kit before.
 */
interface SwitchProps {
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  className?: string;
  "data-attr"?: string;
}

export function Switch({
  checked,
  onChange,
  disabled,
  className = "",
  "data-attr": dataAttr,
}: SwitchProps) {
  return (
    <label
      className={`d-switch ${disabled ? "is-disabled" : ""} ${className}`}
      data-attr={dataAttr}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <span className="track" />
    </label>
  );
}
